(function(){
  function initCountdowns(){
    document.querySelectorAll('[data-aal-countdown]').forEach(function(el){
      if(el.getAttribute('data-aal-countdown-ready')==='true') return;
      el.setAttribute('data-aal-countdown-ready','true');

      function tick(){
        var raw=el.getAttribute('data-aal-countdown');
        if(!raw){el.textContent='—';return;}
        var end=new Date(raw).getTime();
        if(Number.isNaN(end)){el.textContent='—';return;}
        var diff=end-Date.now();
        if(diff<=0){el.textContent='Auction ended';return;}
        var d=Math.floor(diff/86400000); diff%=86400000;
        var h=Math.floor(diff/3600000); diff%=3600000;
        var m=Math.floor(diff/60000); var s=Math.floor((diff%60000)/1000);
        el.textContent=(d?d+'d ':'')+String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s';
      }

      tick();
      setInterval(tick,1000);
    });
  }

  function initGallery(){
    var main=document.querySelector('[data-aal-main-image]');
    if(!main) return;
    var disclaimer=document.querySelector('[data-aal-image-disclaimer]');
    document.querySelectorAll('[data-aal-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var src=btn.getAttribute('data-src');
        var alt=btn.getAttribute('data-alt')||'';
        var isFirst=btn.getAttribute('data-is-first')==='true';
        if(src){main.src=src;main.alt=alt;}
        if(disclaimer){disclaimer.hidden=!isFirst;}
      });
    });
  }

  function initMobileNav(){
    var btn=document.querySelector('[data-aal-menu-toggle]');
    var nav=document.querySelector('[data-aal-nav]');
    if(!btn||!nav)return;
    btn.addEventListener('click',function(){
      var open=nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
  }

  function updateAuctionUI(data){
    if(!data || typeof data!=='object') return;

    if(data.current_bid){
      document.querySelectorAll('[data-aal-current-bid]').forEach(function(x){
        x.textContent=data.current_bid;
      });
    }

    if(data.bid_count!==undefined && data.bid_count!==null){
      document.querySelectorAll('[data-aal-bid-count]').forEach(function(x){
        x.textContent=String(data.bid_count);
      });
    }

    if(data.auction_end){
      document.querySelectorAll('[data-aal-countdown]').forEach(function(x){
        x.setAttribute('data-aal-countdown',data.auction_end);
      });
    }
  }

  function initBidEndpoint(){
    document.querySelectorAll('[data-aal-bid-form]').forEach(function(form){
      var endpoint=form.getAttribute('data-endpoint');
      if(!endpoint) return; // Native Shopify contact-form fallback remains functional.

      form.addEventListener('submit',async function(e){
        e.preventDefault();
        var msg=form.querySelector('[data-aal-bid-message]');
        var submit=form.querySelector('button[type="submit"]');
        var amount=form.querySelector('[name="contact[Bid amount]"]').value;
        var payload={
          product_id:form.getAttribute('data-product-id'),
          variant_id:form.getAttribute('data-variant-id'),
          customer_id:form.getAttribute('data-customer-id'),
          customer_email:form.getAttribute('data-customer-email'),
          amount:amount,
          product_title:form.getAttribute('data-product-title'),
          product_url:form.getAttribute('data-product-url')
        };

        if(submit) submit.disabled=true;
        if(msg) msg.textContent='Submitting your bid…';

        try{
          var res=await fetch(endpoint,{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify(payload)
          });
          var data={};
          try{data=await res.json();}catch(_e){}
          if(!res.ok) throw new Error(data.message||'Bid could not be submitted.');
          updateAuctionUI(data);
          if(msg){
            msg.textContent=data.message||'Bid submitted successfully.';
            msg.className='aal-flash aal-flash--success';
          }
          form.reset();
        }catch(err){
          if(msg){
            msg.textContent=err.message||'Bid could not be submitted.';
            msg.className='aal-flash aal-flash--error';
          }
        }finally{
          if(submit) submit.disabled=false;
        }
      });
    });
  }

  function initAuctionStatusPolling(){
    document.querySelectorAll('[data-aal-auction-status]').forEach(function(root){
      var endpoint=root.getAttribute('data-status-endpoint');
      var productId=root.getAttribute('data-product-id');
      if(!endpoint || !productId) return;

      var separator=endpoint.indexOf('?')===-1?'?':'&';
      var url=endpoint+separator+'product_id='+encodeURIComponent(productId);

      async function poll(){
        try{
          var res=await fetch(url,{headers:{'Accept':'application/json'},cache:'no-store'});
          if(!res.ok) return;
          var data=await res.json();
          updateAuctionUI(data);
        }catch(_e){}
      }

      poll();
      setInterval(poll,20000);
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    initCountdowns();
    initGallery();
    initMobileNav();
    initBidEndpoint();
    initAuctionStatusPolling();
  });
})();
